import AService from '@/services/AService';

const ENTITY_NAME = 'equipment-types';

export default class EquipmentTypeService extends AService {

  /**
   * Gets all equipment types sorted and paged
   * @return {Promise<EquipmentTypeDto[]>}
   */
  async fetchEquipmentTypesPagingAndSorting(params) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/pagingAndSorting`, {params})
    return response.data;
  }

  /**
   * Gets an equipment type with its id
   * @return {Promise<EquipmentTypeDto>}
   */
  async fetchEquipmentType(equipmentTypeId) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/${equipmentTypeId}`)
    return response.data
  }

  /**
   * Creates an equipment type
   * @return {Promise<EquipmentTypeDto>}
   */
  async createEquipmentType(data) {
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}`, data);
    return response.data;
  }

  /**
   * Updates an equipment type
   * @return {Promise<EquipmentTypeDto>}
   */
  async updateEquipmentType(data) {
    const response = await this.http.put(`${this.baseUrl}/${ENTITY_NAME}`, data);
    return response.data
  }

  /**
   * Deletes an equipment type
   * @return {Promise<EquipmentTypeDto>}
   */
  async deleteEquipmentType(id) {
    const response = await this.http.delete(`${this.baseUrl}/${ENTITY_NAME}/${id}`)
    return response.data
  }
}
